document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.sia-section');

  sections.forEach(section => {
    // ---- Thumbnail Navigation Setup ----
    const track = section.querySelector('.sia-track');
    const trackPrev = section.querySelector('.sia-track-prev');
    const trackNext = section.querySelector('.sia-track-next');
    
    // Dynamically show/hide arrows based on precise scroll position
    function updateArrows() {
      if (!track) return;
      
      // Left arrow: hides if scrolled all the way to the left
      if (trackPrev) {
        trackPrev.classList.toggle('is-hidden', track.scrollLeft <= 20);
      }
      
      // Right arrow: calculates absolute maximum scroll distance
      if (trackNext) {
        const maxScroll = track.scrollWidth - track.clientWidth;
        
        // Hides if all items fit on screen (no scroll needed) OR if we scrolled to the end
        const isAtEnd = maxScroll <= 0 || track.scrollLeft >= (maxScroll - 20);
        trackNext.classList.toggle('is-hidden', isAtEnd);
      }
    }

    if (track) {
      // Listen for scrolls/swipes to dynamically update
      track.addEventListener('scroll', updateArrows);
      
      // Execute instantly on page load
      updateArrows();
      
      // Execute on window resize (in case screen orientation changes)
      window.addEventListener('resize', updateArrows);
      
      // Execute once after all assets finish loading (in case lazy-loaded media shifts layout)
      window.addEventListener('load', updateArrows);
    }

    // Button click listeners
    if (track && trackNext) {
      trackNext.addEventListener('click', () => {
        track.scrollBy({ left: 160, behavior: 'smooth' }); 
      });
    }
    if (track && trackPrev) {
      trackPrev.addEventListener('click', () => {
        track.scrollBy({ left: -160, behavior: 'smooth' });
      });
    }

    // ---- Sequential Autoplay Previews Setup ----
    const thumbVideos = section.querySelectorAll('.sia-thumb-video');
    const durationAttr = section.getAttribute('data-preview-duration');
    const PREVIEW_DURATION = durationAttr ? parseInt(durationAttr) * 1000 : 3000; 

    let previewInterval;
    let currentPreviewIndex = 0;

    function playNextPreview() {
      if (thumbVideos.length === 0) return;
      
      thumbVideos.forEach(vid => {
        if (typeof vid.pause === 'function') vid.pause();
      });
      
      const currentVideo = thumbVideos[currentPreviewIndex];
      if (currentVideo && typeof currentVideo.play === 'function') {
        currentVideo.play().catch(e => console.log('Thumbnail autoplay prevented by browser'));
      }
      
      currentPreviewIndex = (currentPreviewIndex + 1) % thumbVideos.length;
    }

    function startPreviewLoop() {
      if (thumbVideos.length > 0) {
        playNextPreview();
        previewInterval = setInterval(playNextPreview, PREVIEW_DURATION);
      }
    }

    function stopPreviewLoop() {
      clearInterval(previewInterval);
      thumbVideos.forEach(vid => {
        if (typeof vid.pause === 'function') {
          vid.pause();
          vid.currentTime = 0;
        }
      });
    }

    startPreviewLoop();

    // ---- Modal & Main Video Setup ----
    const thumbnails = section.querySelectorAll('.sia-thumbnail');
    const modal = section.querySelector('.sia-modal');
    if (!modal) return;
    
    modal.style.display = 'none';
    
    const slides = modal.querySelectorAll('.sia-video-slide');
    const closeBtn = modal.querySelector('.sia-close-btn');
    const prevBtn = modal.querySelector('.sia-prev');
    const nextBtn = modal.querySelector('.sia-next');
    const backdrop = modal.querySelector('.sia-modal-backdrop');
    
    let currentIndex = 0;

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        currentIndex = parseInt(thumb.getAttribute('data-index'));
        openModal();
      });
    });

    function openModal() {
      stopPreviewLoop(); 
      modal.style.display = 'block'; 
      updateSlider();
    }

    function closeModal() {
      modal.style.display = 'none'; 
      pauseAllMainVideos();
      startPreviewLoop(); 
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault(); 
        closeModal();
      });
    }
    
    if (backdrop) {
      backdrop.addEventListener('click', closeModal);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
        updateSlider();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
        updateSlider();
      });
    }

    function updateSlider() {
      pauseAllMainVideos();
      slides.forEach((slide, index) => {
        if (index === currentIndex) {
          slide.classList.add('active');
          
          // Use 'video' tag selector so it doesn't accidentally grab an image tag
          const video = slide.querySelector('video'); 
          if (video && typeof video.play === 'function') {
            if (video.preload === 'none') {
              video.preload = 'metadata';
            }
            video.play().catch(e => console.log('Video autoplay prevented by browser'));
          }
        } else {
          slide.classList.remove('active');
        }
      });
    }

    function pauseAllMainVideos() {
      slides.forEach(slide => {
        // Use 'video' tag selector so we don't try to pause an <img> tag (which causes a JS error)
        const video = slide.querySelector('video');
        if (video && typeof video.pause === 'function') {
          video.pause();
          video.currentTime = 0;
        }
      });
    }
  });
});